import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import SubscriptionTable from '@subscriptions/components/tables/subscription-table/subscription-table.vue';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';

@Component({
  name: 'bpc-subscriptions',
  components: {
    'bpc-subscription-table': SubscriptionTable,
  },
})
export default class Subscription extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}

  get accessControlConfig(): AccessControlConfigInterface {
    return this.$store.getters['centerSettings/accessControlConfig'];
  }

  get extendedFilterConfigName() {
    return this.accessControlConfig?.access_control_service === 'finddoc'
      ? 'extended-with-finddoc-sync'
      : 'extended';
  }
}
